import { useEffect, useRef, useState } from 'react'

/**
 * Animates a number from 0 to target, counting up over ~1.1s.
 * Resets and re-animates whenever `target` changes.
 */
export function useAnimatedNumber(target: number, duration = 1120): number {
  const [current, setCurrent] = useState(0)
  const rafRef = useRef<number>(0)

  useEffect(() => {
    const step = Math.max(1, Math.floor(target / 40))
    let cur = 0

    const tick = () => {
      cur = Math.min(cur + step, target)
      setCurrent(cur)
      if (cur < target) {
        rafRef.current = window.setTimeout(tick, duration / 40)
      }
    }

    // Start from 0 on first tick (handles target === 0 case too)
    rafRef.current = window.setTimeout(tick, 0)

    return () => {
      if (rafRef.current) window.clearTimeout(rafRef.current)
    }
  }, [target, duration])

  return current
}
